module.exports = __webpack_public_path__ + "static/media/PublicChats.a057bb92.png";